#import "../fragments/wf-form-stub-fragment.graphql"

fragment McfxFormFragment on McfxForm {
    id
    lastSubmission {
        id
        createdTime
    }
    submissions {
        totalCount
        edges {
            node {
                id
                createdTime
                form {
                    id
                }
                contact {
                    id
                    nutshellContact {
                        id
                    }
                }
            }
        }
    }
    wfForm {
        ...WfFormStubFragment
    }
}
